import { ORDERS_FILTERS_FORM_FIELDS, ORDERS_FILTERS_FORM_FIELDS_NAMES } from './order-filters-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { timeZonesList } from '../../components/profileSettings/ProfileSettingsPreferences';

const typesList = [
	{
		label: 'MIT',
		value: 'MIT'
	},
	{
		label: 'CIT',
		value: 'CIT'
	},
];

export const ORDER_FILTER_INPUTS = ({ t, statusesList, statusPicker, allStatuses, formik }): IFormInputProps[] => [
	{
		key: ORDERS_FILTERS_FORM_FIELDS.STATUS,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.STATUS,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.STATUS),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.STATUS),
		inputType: InputType.MultiSelect,
		data: statusesList,
		ref: statusPicker,
		searchable: false,
		allValue: allStatuses,
		additionalClasses: 'col-md-6 mb-10 mb-md-0',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.PARTNER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PARTNER_ID),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PARTNER_ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.SITE_ID,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.SITE_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.SITE_ID),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.SITE_ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.ORDER_ID,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.ORDER_ID),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.ORDER_ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EXTERNAL_ORDER_ID),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EXTERNAL_ORDER_ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.TYPE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.TYPE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TYPE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TYPE),
		inputType: InputType.Select,
		data: typesList,
		searchable: false,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.CREATED_DATE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.CREATED_DATE),
		inputType: InputType.DateRange,
		isTimePicker: true,
		additionalClasses: 'col-md-6',
		placement: 'auto',
		defaultDate: formik?.values?.[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_CREATED_DATE],
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PLACED_DATE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PLACED_DATE),
		inputType: InputType.DateRange,
		isTimePicker: true,
		additionalClasses: 'col-md-6',
		placement: 'auto',
		defaultDate: formik?.values?.[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_PLACED_DATE],
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FIRST_NAME),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FIRST_NAME),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.LAST_NAME,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.LAST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_NAME),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_NAME),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.EMAIL,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.EMAIL,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EMAIL),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EMAIL),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.TIMEZONE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.TIMEZONE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TIMEZONE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TIMEZONE),
		inputType: InputType.Select,
		data: timeZonesList,
		cleanable: false,
		placement: 'auto',
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.BIN,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.BIN,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.BIN),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.BIN),
		inputType: InputType.Number,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.LAST_4,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.LAST_4,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_4),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_4),
		inputType: InputType.Number,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
];

export const INTEGRATION_PARTNER_ORDER_FILTER_INPUTS = ({ t, statusesList, statusPicker, allStatuses, formik }): IFormInputProps[] => [
	{
		key: ORDERS_FILTERS_FORM_FIELDS.STATUS,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.STATUS,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.STATUS),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.STATUS),
		inputType: InputType.MultiSelect,
		data: statusesList,
		ref: statusPicker,
		searchable: false,
		allValue: allStatuses,
		additionalClasses: 'col-md-6 mb-10 mb-md-0',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.SITE_ID,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.SITE_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.SITE_ID),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.SITE_ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.ORDER_ID,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.ORDER_ID),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.ORDER_ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.EXTERNAL_ORDER_ID,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EXTERNAL_ORDER_ID),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EXTERNAL_ORDER_ID),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.CREATED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.CREATED_DATE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.CREATED_DATE),
		inputType: InputType.DateRange,
		isTimePicker: true,
		additionalClasses: 'col-md-6',
		placement: 'bottomEnd',
		defaultDate: formik?.values?.[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_CREATED_DATE],
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.PLACED_DATE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PLACED_DATE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.PLACED_DATE),
		inputType: InputType.DateRange,
		isTimePicker: true,
		additionalClasses: 'col-md-6',
		placement: 'bottomEnd',
		defaultDate: formik?.values?.[ORDERS_FILTERS_FORM_FIELDS.DEFAULT_PLACED_DATE],
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.FIRST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FIRST_NAME),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.FIRST_NAME),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.LAST_NAME,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.LAST_NAME,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_NAME),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_NAME),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.EMAIL,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.EMAIL,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EMAIL),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.EMAIL),
		inputType: InputType.Text,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.TYPE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.TYPE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TYPE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TYPE),
		inputType: InputType.Select,
		data: typesList,
		searchable: false,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.BIN,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.BIN,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.BIN),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.BIN),
		inputType: InputType.Number,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.LAST_4,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.LAST_4,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_4),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.LAST_4),
		inputType: InputType.Number,
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
	{
		key: ORDERS_FILTERS_FORM_FIELDS.TIMEZONE,
		fieldName: ORDERS_FILTERS_FORM_FIELDS.TIMEZONE,
		label: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TIMEZONE),
		placeholder: t(ORDERS_FILTERS_FORM_FIELDS_NAMES.TIMEZONE),
		inputType: InputType.Select,
		data: timeZonesList,
		cleanable: false,
		placement: 'auto',
		additionalClasses: 'col-md-6',
		autoComplete: 'off'
	},
];
